module.exports = __webpack_public_path__ + "img/zu6829.3b778551.svg";